export const DISABLED_WEB_LAUNCH_CLIENT_IDS = [
  '3a233d3d-c138-4450-bc67-d669ef6ac544', // NMP 게토 서비스 잠금화면 로그인 APP 모드 Client ID for DEV
  '08dc73bd-4abb-4c58-9e03-8563ccb6d8cc', // NMP 게토 서비스 잠금화면 로그인 APP 모드 Client ID for QA
  '8b57555e-38db-42ad-a709-40810c74a16f', // NMP 게토 서비스 잠금화면 로그인 APP 모드 Client ID for LIVE
]
